import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CintaNaturalOnboarding from '../CintaNaturalOnboarding/CintaNaturalOnboarding';
import { isCintaNaturalOnboardingSearch } from '../../utils/studentPublicLinks';
import { ConsultancyStepSection } from './components/consultancyStep';
import { LandingFaqSection } from './components/landingFaq';
import { MariMessageSection } from './components/mariMessage';
import { OnboardingHeroSection } from './components/onboardingHero';
import { WelcomeVideoSection } from './components/welcomeVideo';

const DefaultOnboardingLandpage: React.FC = () => (
  <>
    <OnboardingHeroSection />
    <WelcomeVideoSection />
    <ConsultancyStepSection />
    <MariMessageSection />
    <LandingFaqSection />
  </>
);

const Landpage: React.FC = () => {
  const [searchParams] = useSearchParams();

  if (isCintaNaturalOnboardingSearch(searchParams)) {
    return <CintaNaturalOnboarding />;
  }

  return <DefaultOnboardingLandpage />;
};

export default Landpage;
